import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CurrentUser {
  id: string;
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
  company_id: string | null;
  company_name: string | null;
  email: string | null;
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;

      const { data: profile } = await supabase
        .from('profiles')
        .select('id, user_id, full_name, avatar_url, company_id')
        .eq('user_id', user.id)
        .single();

      // Fetch company name if user has a company
      let companyName: string | null = null;
      if (profile?.company_id) {
        const { data: company } = await supabase
          .from('companies')
          .select('name, trade_name')
          .eq('id', profile.company_id)
          .single();
        companyName = company?.trade_name || company?.name || null;
      }

      return {
        ...profile,
        email: user.email,
        company_name: companyName,
      } as CurrentUser;
    }
  });
}
